import React from 'react';
import { Grid } from '@mui/material';
import { useCustomTranslation } from '../../../../../../translation/customTranslation';
import { Checkbox } from '../../../../../../components/checkBox/checkBox';
import { TextInput } from '../../../../../../components/textInput/textInput';

interface CellDataProps {
  assessmentQuestion: any;
  onSave: (key: string, value: number | boolean | string) => void;
  data: any;
}
export function CellData({ onSave, assessmentQuestion, data }: CellDataProps) {
  const { t } = useCustomTranslation('assessment');

  return (
    <Grid display="flex" textAlign="left">
      <Grid sx={{ p: 1 }} item xs={12} sm={12} md={2} lg={2}>
        <Checkbox
          name={t('assessment.ID_GENERIC_SKIP_MODULE')}
          onChange={(event) => onSave('notTested', event.target.checked)}
          checked={data?.notTested}
        />
      </Grid>
      <Grid
        display="flex"
        textAlign="center"
        sx={{ mr: 4 }}
        item
        xs={12}
        sm={12}
        md={2}
        lg={2}
      >
        <TextInput
          size="small"
          type="number"
          name=""
          min={assessmentQuestion.headache.range.min}
          max={assessmentQuestion.headache.range.max}
          onChange={(event) => {
            onSave(
              assessmentQuestion.headache.key,
              parseInt(event.target.value, 10),
            );
          }}
          label=""
          value={data ? data[assessmentQuestion.headache.key] : ''}
        />
      </Grid>
      <Grid sx={{ mr: 4 }} item xs={12} sm={12} md={2} lg={2}>
        <TextInput
          size="small"
          type="number"
          name=""
          min={assessmentQuestion.dizziness.range.min}
          max={assessmentQuestion.dizziness.range.max}
          onChange={(event) => {
            onSave(
              assessmentQuestion.dizziness.key,
              parseInt(event.target.value, 10),
            );
          }}
          label=""
          value={data ? data[assessmentQuestion.dizziness.key] : ''}
        />
      </Grid>
      <Grid sx={{ mr: 4 }} item xs={12} sm={12} md={2} lg={2}>
        <TextInput
          size="small"
          type="number"
          name=""
          min={assessmentQuestion.nausea.range.min}
          max={assessmentQuestion.nausea.range.max}
          onChange={(event) => {
            onSave(
              assessmentQuestion.nausea.key,
              parseInt(event.target.value, 10),
            );
          }}
          label=""
          value={data ? data[assessmentQuestion.nausea.key] : ''}
        />
      </Grid>
      <Grid sx={{ mr: 4 }} item xs={12} sm={12} md={2} lg={2}>
        <TextInput
          size="small"
          type="number"
          name=""
          min={assessmentQuestion.fogginess.range.min}
          max={assessmentQuestion.fogginess.range.max}
          onChange={(event) => {
            onSave(
              assessmentQuestion.fogginess.key,
              parseInt(event.target.value, 10),
            );
          }}
          label=""
          value={data ? data[assessmentQuestion.fogginess.key] : ''}
        />
      </Grid>
      <Grid sx={{ mr: 4 }} item xs={12} sm={12} md={2} lg={2}>
        <Grid item flexDirection="column">
          <TextInput
            size="small"
            type="text"
            name=""
            onChange={(event) => {
              onSave(assessmentQuestion.comment.type, event.target.value);
            }}
            label=""
            value={data ? data[assessmentQuestion.comment.type] : ''}
          />
          {assessmentQuestion.rowId === 'vomsConvergence' && (
            <Grid sx={{ mt: 2 }}>
              <TextInput
                size="small"
                type="number"
                name={
                  assessmentQuestion.convergenceNearPointMeasurement1.labelL10n
                    .key
                }
                label={t(
                  assessmentQuestion.convergenceNearPointMeasurement1.labelL10n
                    .key,
                )}
                min={
                  assessmentQuestion.convergenceNearPointMeasurement1.range.min
                }
                max={
                  assessmentQuestion.convergenceNearPointMeasurement1.range.max
                }
                onChange={(event) => {
                  onSave(
                    'convergenceNearPointMeasurement1',
                    parseInt(event.target.value, 10),
                  );
                }}
                value={data ? data.convergenceNearPointMeasurement1 : ''}
              />
              <TextInput
                size="small"
                type="number"
                name={
                  assessmentQuestion.convergenceNearPointMeasurement2.labelL10n
                    .key
                }
                label={t(
                  assessmentQuestion.convergenceNearPointMeasurement2.labelL10n
                    .key,
                )}
                min={
                  assessmentQuestion.convergenceNearPointMeasurement2.range.min
                }
                max={
                  assessmentQuestion.convergenceNearPointMeasurement2.range.max
                }
                onChange={(event) => {
                  onSave(
                    'convergenceNearPointMeasurement2',
                    parseInt(event.target.value, 10),
                  );
                }}
                value={data ? data.convergenceNearPointMeasurement2 : ''}
              />
              <TextInput
                size="small"
                type="number"
                name={
                  assessmentQuestion.convergenceNearPointMeasurement3.labelL10n
                    .key
                }
                label={t(
                  assessmentQuestion.convergenceNearPointMeasurement3.labelL10n
                    .key,
                )}
                min={
                  assessmentQuestion.convergenceNearPointMeasurement3.range.min
                }
                max={
                  assessmentQuestion.convergenceNearPointMeasurement3.range.max
                }
                onChange={(event) => {
                  onSave(
                    'convergenceNearPointMeasurement3',
                    parseInt(event.target.value, 10),
                  );
                }}
                value={data ? data.convergenceNearPointMeasurement3 : ''}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
